import React from "react"
import { useState } from "react"
import { Col, Row } from "react-bootstrap"
import { FeatureTypes } from "./FeatureTypes"
import { FeatureCatalogInfo } from "./ConversionRuleEditor"

export const FeatureTypeMappingSide = (props: { left: boolean; fcInfo: FeatureCatalogInfo }) => {
  const [ftId, setFtId] = useState<number>(0)

  const enableDropping = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault()
  }

  const handleDrop = (event: React.DragEvent<HTMLDivElement>) => {
    if (event.dataTransfer.getData("featureTypeSide") === "left" && props.left) {
      setFtId(Number(event.dataTransfer.getData("featureTypeId")))
    } else if (event.dataTransfer.getData("featureTypeSide") === "right" && !props.left) {
      setFtId(Number(event.dataTransfer.getData("featureTypeId")))
    }
  }

  return (
    <Col
      className={props.left ? "border-right" : "border-right-dashed"}
      md={4}
      onDragOver={enableDropping}
      onDrop={handleDrop}
    >
      {ftId === 0 ? (
        <div className="text-center" style={{ color: "#0C77BE", marginTop: "100px" }}>
          Drag & drop a <b>feature type</b> from the {props.left === true ? "left" : "right"} side here
        </div>
      ) : (
        <Row>
          <FeatureTypes left={props.left} fcId={props.fcInfo.id} ftId={ftId} />
        </Row>
      )}
    </Col>
  )
}

export const FeatureTypeMappingHeading = (props: { left: boolean; fcInfo: FeatureCatalogInfo }) => {
  return (
    <Col className={`text-center py-1 ${props.left ? "border-right" : ""}`} md={4}>
      {`Feature Catalog ${props.left ? "1" : "2"}: `}
      <b>{props.fcInfo.displayText}</b>
    </Col>
  )
}
